<template>
  <div class="mydialog big">
    <DocMsg
      :isFlag="doc_msg"
      :doctorId="doctorId"
    ></DocMsg>

    <el-dialog
      :visible.sync="dialog"
      width="800px"
      style="text-align:left"
      :close-on-click-modal="false"
      center
    >
      <div style="text-align:center;font-size:18px;font-weight:600:color:#333;margin-bottom:20px">
        {{detail.title}}</div>
      <div style="padding: 0 20px">
        <div class="flex between">
          <div>
            <span>作者</span>
            <span style="margin:0 30px 0 20px">{{detail.doctor_name}}</span>
            <span>{{detail.hospital}}</span>
            <span style="margin:0 10px 0 40px">发布时间</span>
            <span>{{detail.create_time}}</span>
          </div>
          <div>{{detail.status==1?"已发布":"已删除"}}</div>
        </div>
        <div
          class="content"
          v-html="detail.content"
        ></div>
        <div
          slot="footer"
          class="dialog-footer"
          style="text-align:center;padding:10px 0"
        >
          <el-button
            type="primary"
            @click="dialog=false"
          >确 定</el-button>
        </div>
      </div>
    </el-dialog>
    <div class="page_title">患教文章(医)</div>
    <div style="padding:20px;border-radius:5px;">
      <div class="container">
        <div>
          <div class="box">
            <div class="searchbox">
              <div>
                <span>医生姓名</span>
                <el-input
                  v-model="doctor_name"
                  style="width:160px;margin:0 20px 0 10px"
                  @input="search"
                  clearable
                ></el-input>
                <span>医生手机号</span>
                <el-input
                  v-model="doctor_phone"
                  style="width:160px;margin:0 20px 0 10px"
                  @input="search"
                  clearable
                ></el-input>
                <span>提交时间</span>
                <el-date-picker
                  v-model="date"
                  type="daterange"
                  range-separator="~"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  clearable
                  style="width:255px;margin:0 10px"
                  @change="search"
                ></el-date-picker>
                <el-button
                  type="info"
                  style="background-color:#eceff2;;color:#747981;"
                  @click="search"
                >查询</el-button>
              </div>
            </div>
            <div class="searchbox">
              <div>
                <span style="margin-right:20px">文章类型</span>
                <el-radio
                  v-model="art_from"
                  :label="0"
                  @change="search"
                >全部</el-radio>
                <el-radio
                  v-model="art_from"
                  :label="1"
                  @change="search"
                >原创</el-radio>
                <el-radio
                  v-model="art_from"
                  :label="2"
                  @change="search"
                >链接</el-radio>
                <el-radio
                  v-model="art_from"
                  :label="3"
                  @change="search"
                >文库</el-radio>
                <span style="margin:0 20px 0 100px">状态</span>
                <el-radio
                  v-model="status"
                  :label="0"
                  @change="search"
                >全部</el-radio>
                <el-radio
                  v-model="status"
                  :label="1"
                  @change="search"
                >已发布</el-radio>
                <el-radio
                  v-model="status"
                  :label="2"
                  @change="search"
                >已删除</el-radio>
              </div>
            </div>
            <div style="border: solid 1px #c9cbd6;">
              <el-table
                ref="multipleTable"
                :data="tableData"
                tooltip-effect="dark"
                style="width: 100%;min-width:1000px;"
                :header-cell-style="{background:'#F5F5F5'}"
              >
                <el-table-column
                  label="发布时间"
                  prop="create_time"
                ></el-table-column>
                <el-table-column label="医生信息">
                  <template slot-scope="scope">
                    <div
                      @click="showDocMsg(scope.row.doctor_id)"
                      style="cursor:pointer"
                    >{{scope.row.doctor_name}}</div>
                    <div>
                      <span style="margin-right:10px">{{scope.row.sex==1?"男":"女"}}</span>
                      <span>{{scope.row.doctor_title}}</span>
                    </div>
                    <div>{{scope.row.phone}}</div>
                  </template>
                </el-table-column>
                <el-table-column
                  label="文章标题"
                  prop="title"
                ></el-table-column>
                <el-table-column label="正文或链接">
                  <template slot-scope="scope">
                    <div class="summary">{{scope.row.summary}}</div>
                  </template>
                </el-table-column>
                <el-table-column label="类型">
                  <template slot-scope="scope">
                    <span v-if="scope.row.art_from==1">原创</span>
                    <span v-if="scope.row.art_from==2">链接</span>
                    <span v-if="scope.row.art_from==3">文库</span>
                  </template>
                </el-table-column>
                <el-table-column label="状态">
                  <template slot-scope="scope">
                    <span v-if="scope.row.status==1">已发布</span>
                    <span v-if="scope.row.status==2">已删除</span>
                  </template>
                </el-table-column>
                <el-table-column label="操作">
                  <template slot-scope="scope">
                    <el-button
                      type="text"
                      @click="toDetail(scope.row)"
                    >查看</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div>
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="10"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalNum"
                style="margin:20px 0"
              ></el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import DocMsg from '../../../components/common/DocMsg.vue';
import platform from '../../../api/platform';
import yewu from '../../../api/yewu';
import moment from 'moment';
export default {
  data() {
    return {
      currentPage: 1,
      pagesize: 10,
      totalNum: 0,
      tableData: [],
      doctor_name: '',
      doctor_phone: '',
      date: [],
      status: 0,
      art_from: 0,
      detail: {},
      dialog: false,
      doc_msg: false,
      doctorId: ''
    };
  },
  components: {
    DocMsg
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    }
  },
  methods: {
    //医生信息概要
    showDocMsg(doctor_id) {
      this.doctorId = doctor_id;
      this.doc_msg = !this.doc_msg;
    },
    //获取列表
    getList() {
      let data = {
        page: this.currentPage,
        pageNumber: this.pagesize,
        doctor_name: this.doctor_name,
        doctor_phone: this.doctor_phone,
        status: this.status,
        art_from: this.art_from
      };
      if (this.date && this.date.length > 0) {
        data.start_time = moment(this.date[0]).format('YYYY-MM-DD');
        data.end_time = moment(this.date[1]).format('YYYY-MM-DD');
      }
      yewu.getArticleList(data).then((res) => {
        if (res.code == 0) {
          this.tableData = res.data.list.map((item) => {
            item.create_time = platform.timestampToTime(item.create_time);
            return item;
          });
          this.totalNum = res.data.total;
        }
      });
    },
    search() {
      this.currentPage = 1;
      this.getList();
    },
    //查看
    toDetail(row) {
      if (row.art_from == 1 || row.art_from == 3) {
        this.detail = row;
        this.detail.content = this.detail.content.replace(
          /<img/,
          "<img style='max-width:700px'"
        );
        this.dialog = true;
      } else {
        window.open(row.summary, '_blank');
      }
    },
    //每页数据的条数
    handleSizeChange(size) {
      this.pagesize = size;
      this.getList();
    },
    //当前第几页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getList();
    }
  },
  created() {
    this.getList();
  }
};
</script>
<style lang="scss" scoped>
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}

.box {
  width: 100%;
  box-sizing: border-box;
  padding: 20px;
  .searchbox {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
  }
}
.videobox {
  width: 100px;
  height: 70px;
  position: relative;
  cursor: pointer;
  .videoimg {
    width: 100%;
    height: 100%;
  }
  .onvideo {
    width: 30px;
    position: absolute;
    top: 20px;
    left: 35px;
  }
}
.imgbox {
  display: flex;
  padding: 30px;
  box-sizing: border-box;
  justify-content: space-between;
}
.uploadimg {
  width: 242px;
  height: 182px;
  box-sizing: border-box;
  background-color: #fff;
  border: dashed 1px #d6d6d6;

  .avatar {
    width: 240px;
    height: 180px;
  }
  .uploader-icon {
    padding-top: 30px;
    line-height: 30px;
    color: #669961;
  }
}
.summary {
  display: -webkit-box;
  word-break: break-all;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.content {
  margin-top: 20px;
  box-sizing: border-box;
  padding: 20px;
  background: #e8e8e8;
  color: #333;
  min-height: 300px;
  overflow: hidden;
}
</style>
<style lang="scss">
.mydialog .mydia .el-dialog__header {
  border-radius: 5px 5px 0 0;
  border-bottom: solid 1px #dcdcde;
  text-align: left;
  font-weight: 600;
}

.mydialog .mydia .el-dialog {
  border-radius: 5px;
}

.mydialog .mydia .el-dialog__body {
  padding: 0px 0px 30px;
  color: #262626;
}
</style>